<template>
  <nav class="main-header-menu">
    <h2 class="a11y-hidden">메뉴 네비게이션</h2>
    <ul class="nav-list">
      <li v-for="(item, index) in mainMenuItems" :key="index">
        <router-link :to="{name: mapUICodeToPath(item.uicode)}" active-class="on" exact>
          {{item.title}}
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapUICodeToPath } from '@/common/util/menu.util'
export default {
  name: 'MainMenu',
  props: {},
  methods: {
    mapUICodeToPath
  },
  computed: {
    ...mapGetters(['mainMenuItems'])
  }
}
</script>
<style scoped>
  .main-header-menu {}
  nav {
    background-color: #1b1b1b;
  }
</style>
